"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuckyBoxStatusInfoSchema = exports.LuckyBoxParticipateSchema = exports.LuckyBoxAvailableSchema = exports.LuckyBoxInfoSchema = exports.LuckyBoxContentSchema = exports.LuckyBoxPromotionSchema = exports.LuckyBoxBaseInputSchema = exports.LuckyBoxStatus = void 0;
var zod_1 = require("zod");
exports.LuckyBoxStatus = {
    /** 프로모션 기간이 아닐 경우 */
    NOT_PROMOTION_PERIOD: 'NOT_PROMOTION_PERIOD',
    /** 이미 참여했을 경우 */
    ALREADY_PARTICIPATED: 'ALREADY_PARTICIPATED',
    /** 로그인이 안되어 있을 경우 */
    NEED_LOGIN: 'NEED_LOGIN',
    /** 참여 가능 */
    AVAILABLE_PARTICIPATION: 'AVAILABLE_PARTICIPATION',
    /** 참여 중 */
    PARTICIPATING: 'PARTICIPATING',
    /** 마케팅 동의 누르지 않을 경우 */
    NOT_MARKETING_AGREED: 'NOT_MARKETING_AGREED',
};
exports.LuckyBoxBaseInputSchema = zod_1.z.object({
    policyCode: zod_1.z.string(),
    requestAt: zod_1.z.string().optional(),
});
// 럭키 박스 프로모션 정보 스키마
exports.LuckyBoxPromotionSchema = zod_1.z.object({
    title: zod_1.z.string(),
    requiredMarketingAgreement: zod_1.z.boolean(),
    startAt: zod_1.z.string(),
    endAt: zod_1.z.string(),
    useYn: zod_1.z.boolean(),
});
// 럭키 박스 프로모션 내용 스키마
exports.LuckyBoxContentSchema = zod_1.z.object({
    style: zod_1.z.object({
        backgroundColor: zod_1.z.string().nullish(),
        buttonColor: zod_1.z.string().nullish(),
        buttonBackgroundColor: zod_1.z.string().nullish(),
    }),
    images: zod_1.z.array(zod_1.z.object({
        section: zod_1.z.enum(['KEY_VISUAL', 'INFORM']),
        sequence: zod_1.z.number(),
        condition: zod_1.z
            .enum([
            exports.LuckyBoxStatus.AVAILABLE_PARTICIPATION,
            exports.LuckyBoxStatus.PARTICIPATING,
            exports.LuckyBoxStatus.ALREADY_PARTICIPATED,
        ])
            .nullable(),
        url: zod_1.z.string(),
        altText: zod_1.z.string().nullish(),
    })),
    buttons: zod_1.z.array(zod_1.z.object({
        type: zod_1.z.string(),
        sequence: zod_1.z.number(),
        condition: zod_1.z.enum([exports.LuckyBoxStatus.AVAILABLE_PARTICIPATION, exports.LuckyBoxStatus.ALREADY_PARTICIPATED]).nullish(),
        displayName: zod_1.z.string(),
        link: zod_1.z.string().nullish(),
    })),
    caution: zod_1.z
        .object({
        cautionText: zod_1.z.string().nullish(),
        detailCautionText: zod_1.z.string().nullish(),
    })
        .nullish(),
    share: zod_1.z
        .object({
        imageUrl: zod_1.z.string(),
        title: zod_1.z.string(),
        shareText: zod_1.z.string(),
        buttonDisplayName: zod_1.z.string(),
    })
        .nullish(),
});
exports.LuckyBoxInfoSchema = zod_1.z.object({
    promotion: exports.LuckyBoxPromotionSchema,
    content: exports.LuckyBoxContentSchema,
});
exports.LuckyBoxAvailableSchema = zod_1.z.object({
    available: zod_1.z.boolean(),
    reason: zod_1.z.enum([exports.LuckyBoxStatus.ALREADY_PARTICIPATED, exports.LuckyBoxStatus.NOT_PROMOTION_PERIOD]).nullish(),
});
exports.LuckyBoxParticipateSchema = zod_1.z.object({
    benefitType: zod_1.z.enum(['POINT', 'COUPON', 'GOODS', 'NOL_POINT']).nullish(),
    displayImageUrl: zod_1.z.string(),
});
/**
 * 럭키 박스 프로모션 상태 정보 응답
 */
exports.LuckyBoxStatusInfoSchema = zod_1.z.object({
    info: exports.LuckyBoxInfoSchema,
    status: zod_1.z.enum([
        exports.LuckyBoxStatus.AVAILABLE_PARTICIPATION,
        exports.LuckyBoxStatus.ALREADY_PARTICIPATED,
        exports.LuckyBoxStatus.NOT_PROMOTION_PERIOD,
        exports.LuckyBoxStatus.NEED_LOGIN,
    ]),
    marketingPrivacy: zod_1.z.boolean().nullish(),
    marketingPush: zod_1.z.boolean().nullish(), // 마케팅 PUSH 수신 동의 여부(isMarketingPushReceived)
});
